function getNestedValue(obj, path) {
    return path.split(".").reduce((acc, key) => acc?.[key], obj);
}

function validate(form, rules) {
    const errors = {};
    Object.entries(rules).forEach(([field, rule]) => {
        const value = getNestedValue(form, field);
        const isEmpty = value === undefined || value === null || value === "";

        if (rule.required && isEmpty) {
            errors[field] = `${rule.label ?? field} is required`;
            return;
        }
        if (!isEmpty && rule.pattern && !rule.pattern.test(value)) {
            errors[field] = rule.message ?? `${rule.label ?? field} is invalid`;
        }
    });
    return errors;
}

export { validate };
